module.exports = __webpack_public_path__ + "static/2021-03-27-09-30-25-048-fs8-fs8-22f1f37da8fcbf4a7fc82a9108dc6644.png";